import { render, staticRenderFns } from "./cAIContent.vue?vue&type=template&id=4f2d3b7c&scoped=true"
import script from "./cAIContent.vue?vue&type=script&lang=js"
export * from "./cAIContent.vue?vue&type=script&lang=js"
import style0 from "./cAIContent.vue?vue&type=style&index=0&id=4f2d3b7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d3b7c",
  null
  
)

export default component.exports